import { Link } from "react-router-dom";
import { Instagram, Youtube } from "lucide-react";
import { customerRulesPath } from "@/lib/businessRules";
import BrandLogo from "@/components/BrandLogo";
import { openCookieSettings } from "@/components/CookieConsent";

export default function Footer({ inert = false }) {
  return <footer inert={inert} className="min-w-0 max-w-full border-t border-brand-line bg-white">
    <div className="mx-auto grid w-full min-w-0 max-w-[1240px] grid-cols-2 gap-8 px-4 py-9 text-xs sm:px-8 md:grid-cols-5">
      <Link to="/" className="min-w-0 self-start" aria-label="SpørgMig forside"><BrandLogo/></Link>
      <Group title="Udforsk" items={[
        ["Sådan virker det", "/#saadan-virker-det"],
        ["Find hjælp", "/eksperter"],
        ["Alle kategorier", "/kategorier"],
        ["Viden & guides", "/blog"],
        ["Tjen på din viden", "/tjen-penge-paa-din-viden"],
      ]}/>
      <Group title="Om SpørgMig" items={[
        ["Om SpørgMig", "/om-spoergmig"],
        ["Sådan godkendes profiler", "/ekspertgodkendelse"],
        ["Sikkerhed", "/sikkerhed"],
      ]}/>
      <Group title="Hjælp" items={[
        ["Kontakt", "/kontakt"],
        ["Spørgsmål og svar", "/hjaelp"],
        ["Betaling, afbud og regler", customerRulesPath],
      ]}/>
      <div className="min-w-0">
        <h3 className="font-semibold text-brand-ink">Følg os</h3>
        <div className="mt-3 flex gap-2">
          <span className="rounded-full border p-2" aria-label="Instagram"><Instagram size={14}/></span>
          <span className="rounded-full border p-2" aria-label="YouTube"><Youtube size={14}/></span>
        </div>
      </div>
      <div className="col-span-full min-w-0 border-t border-brand-line pt-6">
        <ul className="flex flex-wrap gap-x-6 gap-y-3 text-brand-body">
          <li><Link to="/vilkaar" className="hover:text-brand-fresh">Brugervilkår</Link></li>
          <li><Link to="/privatliv" className="hover:text-brand-fresh">Privatlivspolitik</Link></li>
          <li><Link to="/cookies" className="hover:text-brand-fresh">Cookiepolitik</Link></li>
          <li><button type="button" onClick={openCookieSettings} className="text-left hover:text-brand-fresh">Cookieindstillinger</button></li>
        </ul>
      </div>
    </div>
  </footer>;
}

function Group({ title, items }) {
  return <div className="min-w-0">
    <h3 className="break-words font-semibold text-brand-ink">{title}</h3>
    <ul className="mt-3 min-w-0 space-y-2 text-brand-body">
      {items.map(([label, to]) => <li key={label} className="min-w-0"><Link to={to} className="break-words hover:text-brand-fresh">{label}</Link></li>)}
    </ul>
  </div>;
}

